import { ActionReducer, createReducer, on } from '@ngrx/store';
import { AppStoreState } from './app-store.state';
import { AppStoreActions } from './app-store.actions';

//screen size controller
export const AppStoreReducer: ActionReducer<AppStoreState> = createReducer(
  AppStoreState,
  //mobile menu controller
  on(AppStoreActions.showMobileMenu, state => ({ ...state, isVisible: true })),
  on(AppStoreActions.hideMobileMenu, state => ({ ...state, isVisible: false })),
  on(AppStoreActions.toggleMobileMenu, state => ({ ...state, isVisible: !state.isVisible })),
  //========================================================================================================================
  //mobile chat bot controller
  on(AppStoreActions.showMobileChatBot, state => ({ ...state, isMobileChatBotVisible: true })),
  on(AppStoreActions.hideMobileChatBot, state => ({ ...state, isMobileChatBotVisible: false })),
  //========================================================================================================================
  //search query controller
  on(AppStoreActions.setSearchQuery, (state, { searchQuery }) => ({ ...state, searchQuery })),
  on(AppStoreActions.resetSearchQuery, state => ({ ...state, searchQuery: '', searchId: null, preserveSearchId: false })),
  on(AppStoreActions.setSearchStatus, (state, { searchStatus }) => ({ ...state, searchStatus })),
  on(AppStoreActions.setOffersSearchStatus, (state, { offersSearchStatus }) => ({ ...state, offersSearchStatus })),
  on(AppStoreActions.setSearchId, (state, { searchId }) => ({ ...state, searchId })),
  on(AppStoreActions.setPreserveSearchId, (state, { preserveSearchId }) => ({ ...state, preserveSearchId })),
  //========================================================================================================================
  //narrow class adding controller
  on(AppStoreActions.enableNarrowLayout, state => ({ ...state, isNarrowLayout: true })),
  on(AppStoreActions.disableNarrowLayout, state => ({ ...state, isNarrowLayout: false })),
);
